// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ai-0";
export var orangeButton = "_ai-1";